<template>
    <div class="content">
        <activity-board-call-history></activity-board-call-history>
    </div>
</template>

<script>import script from './CallHistory';
    export default script;</script>
